import {CP, IP} from "../setting/initParam";
import {
    calcCountInLength, createDefaultMaterial, getCoordinateOnDiagonal, InitialStruct,
    matBeam, ParamsGetSimpleBoard, RenderElement,
    RenderStruct, simpleSize, unCenteredLine, Vec2, Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";
import {locale} from "../setting/locale";

export async function getSheathing(s:InitialStruct, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {
    const lang = new URLSearchParams(window.location.search).get('lang') as 'en'|'de'|'ru' || 'en';

    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    const specIds: string[] = []
    const offset = s.e.back + s.l / 2

    const uncentered = CP.maps.rafter.mapCentered
        .map(p => [p[0] + offset, p[1]] as Vec2)

    const seg = calcCountInLength(
        uncentered,
        [[0, 0], [s.l + s.e.back + s.e.front, 0]],
        IP.elementData.sheathing.sizeBoard.minL,
        IP.elementData.sheathing.sizeBoard.maxL,
        0,
        0,
    )

    const countL = Math.floor(CP.maps.rafter.l.left / (sBoard.w + IP.setting.sheathingSpan));
    const countR = Math.floor(CP.maps.rafter.l.right / (sBoard.w + IP.setting.sheathingSpan));
    let lastBoardWL = CP.maps.rafter.l.left - (sBoard.w + IP.setting.sheathingSpan) * (countL);
    let lastBoardWR = CP.maps.rafter.l.right - (sBoard.w + IP.setting.sheathingSpan) * (countR);

    let shiftR = 0
    let shiftL = 0

    const shiftZ = s.h
        - IP.gash.simple
        - IP.gash.simple
        - IP.gash.simple
        + CP.maps.rafter.hGash
        + IP.elementData.sheathing.sizeBoard.h / 2

        + IP.elementData.f2.sizeBoard.l
        + IP.elementData.ridge.sizeBoard.h
        + IP.elementData.f1.sizeBoard.h

    const nameGroup = IP.elementData.sheathing.groupName || 'sheathing'
    const nameElement = IP.elementData.sheathing.name || 'sheathing'
    rs.group = nameGroup
    const numGroups = rs.group.length
    rs.material.push(createDefaultMaterial())

    for (let b = 0; b < seg.segments.length; b++) {

        const specID = nameElement + '_' + b
        const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
            modeBuild: modeBuild,
            shift: {back: 0, front: 0},
            sizeBoard: {w: sBoard.w, h: sBoard.h, l:  seg.segments[b].length},
            cuts: [],
        }

        const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
        rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
        rs.indices.push(resultGetSimpleBoard.mesh.indices)
        rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
        const numUvs = rs.uvs.length - 1
        const numIndices = rs.indices.length - 1
        const numVertices = rs.vertices.length - 1
        const meta = resultGetSimpleBoard.meta

        const x = seg.segments[b].from[0] - s.l/2 -s.e.back + meta.l / 2 +0.002*b //- s.e.back + s.e.front

        let num = 0

        for (let i = 0; i < countR; i++) {

            shiftR = (IP.elementData.sheathing.sizeBoard.w + IP.setting.sheathingSpan) * i + IP.elementData.sheathing.sizeBoard.w / 2

            const shiftZYR = getCoordinateOnDiagonal(s.a, -shiftR)

            const z = shiftZ
                - shiftZYR.dY

            const yR =
                - shiftZYR.dZ

            const posR:Vec3 = [x, z, yR]

            const boardR: RenderElement = {
                indices: numIndices,
                name: `${nameGroup} - ${num}`,
                nameGroup: nameGroup,
                position: posR,
                // rotation: [Math.PI / 2, 0, Math.PI / 2,],
                rotation: [Math.PI / 2 - s.r, 0, Math.PI / 2,],
                uvs: numUvs,
                vertices: numVertices,
                material: 0,
                specId: specID,
            }
            rs.elements.push(boardR)
            num++
        }
        spec.push({
            w: resultGetSimpleBoard.meta.w,
            h: resultGetSimpleBoard.meta.h,
            l: resultGetSimpleBoard.meta.l,
            name: nameElement,
            group: nameGroup,
            count: countR,
            materialId: IP.elementData.sheathing.materialId,
            specId: specID,
        })

        for (let i = 0; i < countL; i++) {

            shiftL = (IP.elementData.sheathing.sizeBoard.w + IP.setting.sheathingSpan) * i + IP.elementData.sheathing.sizeBoard.w / 2

            const shiftZYL = getCoordinateOnDiagonal(s.a, -shiftL)
            const z = shiftZ
                - shiftZYL.dY

            const yL =
                + shiftZYL.dZ

            const posL:Vec3 = [x, z, yL]

            const boardL: RenderElement = {
                indices: numIndices,
                name: `${nameGroup} - ${num}`,
                nameGroup: nameGroup,
                position: posL,
                // rotation: [Math.PI / 2, 0, Math.PI / 2,],
                rotation: [Math.PI / 2 + s.r, 0, Math.PI / 2,],
                uvs: numUvs,
                vertices: numVertices,
                material: 0,
                specId: specID,
            }
            rs.elements.push(boardL)
            num++
        }
        spec.push({
            w: resultGetSimpleBoard.meta.w,
            h: resultGetSimpleBoard.meta.h,
            l: resultGetSimpleBoard.meta.l,
            name: nameElement,
            group: nameGroup,
            count: countL,
            materialId: IP.elementData.sheathing.materialId,
            specId: specID,
        })
        specIds.push(specID)
        {
            const specIDlast = nameElement + '_LLast_' + b
            const paramsGetSimpleBoardLL: ParamsGetSimpleBoard = {
                modeBuild: modeBuild,
                shift: {back: 0, front: 0},
                sizeBoard: {w: lastBoardWL, h: sBoard.h, l: seg.segments[b].length},
                cuts: [],
            }
            const resultGetSimpleBoardLL = await api.getSimpleBoard.build(paramsGetSimpleBoardLL)
            rs.uvs.push(resultGetSimpleBoardLL.mesh.uvs)
            rs.indices.push(resultGetSimpleBoardLL.mesh.indices)
            rs.vertices.push(resultGetSimpleBoardLL.mesh.vertices)
            const numUvsLL = rs.uvs.length - 1
            const numIndicesLL = rs.indices.length - 1
            const numVerticesLL = rs.vertices.length - 1
            const metaLL = resultGetSimpleBoardLL.meta

            const shiftZYL = getCoordinateOnDiagonal(s.a, -(shiftL + metaLL.w / 2 + IP.elementData.sheathing.sizeBoard.w / 2))
            const z = shiftZ
                - shiftZYL.dY

            const yL =
                +shiftZYL.dZ

            const posL: Vec3 = [x, z, yL]

            const boardL: RenderElement = {
                indices: numIndicesLL,
                name: `${nameGroup} - ${num}`,
                nameGroup: nameGroup,
                position: posL,
                // rotation: [Math.PI / 2, 0, Math.PI / 2,],
                rotation: [Math.PI / 2 + s.r, 0, Math.PI / 2,],
                uvs: numUvsLL,
                vertices: numVerticesLL,
                material: 0,
                specId: specIDlast,
            }
            rs.elements.push(boardL)
            num++
            spec.push({
                w: resultGetSimpleBoard.meta.w,
                h: resultGetSimpleBoard.meta.h,
                l: resultGetSimpleBoard.meta.l,
                name: nameElement,
                group: nameGroup,
                count: 1,
                materialId: IP.elementData.sheathing.materialId,
                specId: specIDlast,
            })
            specIds.push(specIDlast)
        }
        {
            const specIDlast = nameElement + '_RLast_' + b
            const paramsGetSimpleBoardRR: ParamsGetSimpleBoard = {
                modeBuild: modeBuild,
                shift: {back: 0, front: 0},
                sizeBoard: {w: lastBoardWR, h: sBoard.h, l: seg.segments[b].length},
                cuts: [],
            }
            const resultGetSimpleBoardRR = await api.getSimpleBoard.build(paramsGetSimpleBoardRR)
            rs.uvs.push(resultGetSimpleBoardRR.mesh.uvs)
            rs.indices.push(resultGetSimpleBoardRR.mesh.indices)
            rs.vertices.push(resultGetSimpleBoardRR.mesh.vertices)
            const numUvsRR = rs.uvs.length - 1
            const numIndicesRR = rs.indices.length - 1
            const numVerticesRR = rs.vertices.length - 1
            const metaRR = resultGetSimpleBoardRR.meta

            const shiftZYR = getCoordinateOnDiagonal(s.a, -(shiftR + metaRR.w / 2 + IP.elementData.sheathing.sizeBoard.w / 2))
            const z = shiftZ
                - shiftZYR.dY

            const yR =
                -shiftZYR.dZ

            const posR: Vec3 = [x, z, yR]

            const boardR: RenderElement = {
                indices: numIndicesRR,
                name: `${nameGroup} - ${num}`,
                nameGroup: nameGroup,
                position: posR,
                // rotation: [Math.PI / 2, 0, Math.PI / 2,],
                rotation: [Math.PI / 2 - s.r, 0, Math.PI / 2,],
                uvs: numUvsRR,
                vertices: numVerticesRR,
                material: 0,
                specId: specIDlast,
            }
            rs.elements.push(boardR)
            spec.push({
                w: resultGetSimpleBoard.meta.w,
                h: resultGetSimpleBoard.meta.h,
                l: resultGetSimpleBoard.meta.l,
                name: nameElement,
                group: nameGroup,
                count: 1,
                materialId: IP.elementData.sheathing.materialId,
                specId: specIDlast,
            })
            specIds.push(specIDlast)
        }
    }
    rs.specIds = specIds
    return {rs: rs, spec: spec}
}
